import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckDetails } from '@api/hitoryCheck';

import { extractQueryParams } from '@utils/common';

import { THistoryCheckDetailsDTO } from '@interfaces/cmModule/dto/historyCheckDTO';
import { THistoryCheckDetails } from '@interfaces/cmModule/historyCheck';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_DETAILS } from '@constants/queryKeys';

interface IUseQueryHistoryCheckDetailsReturnValue {
	historyDetails?: THistoryCheckDetails;
	isLoadingDetails: boolean;
	isFetchingDetails: boolean;
}

export const useQueryHistoryCheckDetails = (
	params: THistoryCheckDetailsDTO & { isAwtgRanVendor?: boolean },
): IUseQueryHistoryCheckDetailsReturnValue => {
	const {
		data: historyDetails,
		isLoading: isLoadingDetails,
		isFetching: isFetchingDetails,
	} = useQuery<THistoryCheckDetails>({
		queryFn: extractQueryParams(getHistoryCheckDetails),
		queryKey: [HISTORY_CHECK_DETAILS, params],
		enabled: [!!params?.comparisonId && !params?.isAwtgRanVendor],
		...refetchOptions,
	});

	return {
		historyDetails,
		isLoadingDetails: isLoadingDetails || isFetchingDetails,
		isFetchingDetails,
	};
};
